<template>
  <div v-if="isShow" class="history_wrapper">
    <h2 class="access_hidden">포인트 전환 내역</h2>
    <point-info a2s="exchangeHistory" />
    <template v-if="userRegion === 'krpc'">
      <exchange-list />
    </template>
    <template v-else>
      <global-exchange-list />
    </template>

    <exchange-detail-layer />
    <exchange-account-layer />
  </div>
</template>

<script>
import PointInfo from '@/components/modules/common/PointInfo';
import ExchangeList from '@/components/modules/exchangeHistory/ExchangeList';
import GlobalExchangeList from '@/components/modules/exchangeHistory/ExchangeList/global';
import ExchangeDetailLayer from '@/components/modules/exchangeHistory/ExchangeDetailLayer';
import ExchangeAccountLayer from '@/components/modules/exchangeHistory/ExchangeAccountLayer';
import { goToLoginPage, isLogin, setServiceUrl, checkUserRegion } from '@/utils';

export default {
  components: {
    PointInfo,
    ExchangeList,
    GlobalExchangeList,
    ExchangeDetailLayer,
    ExchangeAccountLayer,
  },
  data() {
    return {
      isShow: false,
    };
  },
  computed: {
    userRegion() {
      return checkUserRegion();
    },
  },
  created() {
    const { serviceUrl } = this.$route.params;
    if (!serviceUrl) {
      this.$router.push({ path: '/', query: { ...this.$route.query } });
    } else {
      setServiceUrl(serviceUrl);
    }

    if (!isLogin()) {
      goToLoginPage();
    } else {
      this.isShow = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.history_wrapper {
  padding: 50px 30px 0 30px;
}

@media all and (max-width: 767px) {
  .history_wrapper {
    padding: 30px 15px 0 15px;
  }
}

@media all and (max-width: 480px) {
  .history_wrapper {
    padding: 30px 0 0;
  }
}
</style>
